module.exports = __webpack_public_path__ + "static/media/autex-acoustic.a1497637.png";